import React from "react";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme, { buttonClasses } from "../../../static/styles/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw", // responsive width
  maxWidth: 900,
  height: "auto",
  maxHeight: "90vh", // prevents overflow on small screens
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "6px",
  p: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const FileModal = ({ openModal, displayUrl, setOpenModal }) => {
  const handleClose = () => setOpenModal(false);
  const hideModal = () => {
    setOpenModal(false);
  };
  const cancelHandler = () => {
    setOpenModal(false);
  };
  const handleDownload = () => {
    window.open(displayUrl, "_blank");
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <img
          style={{
            maxHeight: "70vh", // fit inside viewport height
            maxWidth: "100%", // responsive width
            objectFit: "contain",
            borderRadius: "4px",
          }}
          src={displayUrl}
          alt="Preview"
        />

        {/* Buttons wrapper */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mt: 2,
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          <button
            onClick={cancelHandler}
            style={{
              fontWeight: "300",
              fontSize: "12px",
              padding: "6px 20px",
              ...buttonClasses.lynkitBlackFill,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleDownload}
            style={{
              fontWeight: "300",
              fontSize: "12px",
              padding: "6px 20px",
              ...buttonClasses.lynkitOrangeFill,
            }}
          >
            Download
          </button>
        </Box>

        <CloseIcon
          sx={{
            position: "absolute",
            right: "0.3%",
            top: "0.3%",
            cursor: "pointer",
          }}
          onClick={hideModal}
          className="crossIconPri"
        />
      </Box>
    </Modal>
  );
};

export default FileModal;
